module.exports = __webpack_public_path__ + "static/media/swoosh.64373e7a.mp3";